// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/key.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { KeyIdentity } from "../../common/v1/common_pb.js";
import { file_console_common_v1_common } from "../../common/v1/common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/key.proto.
 */
export const file_console_admin_v1_key: GenFile = /*@__PURE__*/
  fileDesc("Chpjb25zb2xlL2FkbWluL3YxL2tleS5wcm90bxIQY29uc29sZS5hZG1pbi52MSLHAgoDS2V5EjAKCGlkZW50aXR5GAEgASgLMh4uY29uc29sZS5jb21tb24udjEuS2V5SWRlbnRpdHkSEgoKY3JlYXRlZF9ieRgCIAEoCRIuCgpjcmVhdGVkX2F0GAMgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIvCgtwcm9tb3RlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKcmV0aXJlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFwoPZGV2aWNlc19mZXRjaGVkGAcgASgNEhYKDmRldmljZXNfYWN0aXZlGAggASgNEg8KB2hlbGRfaW4YCiABKAlKBAgGEAdKBAgJEApSDGRlc3Ryb3llZF9hdFINcHJvbW90YWJsZV9hdCIhCg9Nb3ZlS2V5c1JlcXVlc3QSDgoGb3JnX2lkGAEgASgJIkYKEE1vdmVLZXlzUmVzcG9uc2USDQoFbW92ZWQYASABKA0SIwoEa2V5cxgCIAMoCzIVLmNvbnNvbGUuYWRtaW4udjEuS2V5IiQKElJlc3RvcmVLZXlzUmVxdWVzdBIOCgZvcmdfaWQYASABKAkiTAoTUmVzdG9yZUtleXNSZXNwb25zZRIQCghyZXN0b3JlZBgBIAEoDRIjCgRrZXlzGAIgAygLMhUuY29uc29sZS5hZG1pbi52MS5LZXkiIQoPTGlzdEtleXNSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCSJKChBMaXN0S2V5c1Jlc3BvbnNlEiMKBGtleXMYASADKAsyFS5jb25zb2xlLmFkbWluLnYxLktleRIRCglrZXlfc3RvcmUYAiABKAkiSAoQQ3JlYXRlS2V5UmVxdWVzdBIOCgZvcmdfaWQYASABKAkSEgoKZ2VuZXJhdGlvbhgCIAEoCRIQCghyZXBsYWNlcxgDIAEoCSJwChFDcmVhdGVLZXlSZXNwb25zZRIiCgNrZXkYASABKAsyFS5jb25zb2xlLmFkbWluLnYxLktleRImCgdyZXRpcmVkGAIgASgLMhUuY29uc29sZS5hZG1pbi52MS5LZXkSDwoHd2FybmluZxgDIAEoCSJLChVEb3dubG9hZEVzY3Jvd1JlcXVlc3QSDgoGb3JnX2lkGAEgASgJEhIKCmdlbmVyYXRpb24YAiABKAkSDgoGcmVhc29uGAMgASgJIiUKFkRvd25sb2FkRXNjcm93UmVzcG9uc2USCwoDa2V5GAEgASgJMskDCgpLZXlTZXJ2aWNlElEKCExpc3RLZXlzEiEuY29uc29sZS5hZG1pbi52MS5MaXN0S2V5c1JlcXVlc3QaIi5jb25zb2xlLmFkbWluLnYxLkxpc3RLZXlzUmVzcG9uc2USVAoJQ3JlYXRlS2V5EiIuY29uc29sZS5hZG1pbi52MS5DcmVhdGVLZXlSZXF1ZXN0GiMuY29uc29sZS5hZG1pbi52MS5DcmVhdGVLZXlSZXNwb25zZRJjCg5Eb3dubG9hZEVzY3JvdxInLmNvbnNvbGUuYWRtaW4udjEuRG93bmxvYWRFc2Nyb3dSZXF1ZXN0GiguY29uc29sZS5hZG1pbi52MS5Eb3dubG9hZEVzY3Jvd1Jlc3BvbnNlElEKCE1vdmVLZXlzEiEuY29uc29sZS5hZG1pbi52MS5Nb3ZlS2V5c1JlcXVlc3QaIi5jb25zb2xlLmFkbWluLnYxLk1vdmVLZXlzUmVzcG9uc2USWgoLUmVzdG9yZUtleXMSJC5jb25zb2xlLmFkbWluLnYxLlJlc3RvcmVLZXlzUmVxdWVzdBolLmNvbnNvbGUuYWRtaW4udjEuUmVzdG9yZUtleXNSZXNwb25zZWIGcHJvdG8z", [file_google_protobuf_timestamp, file_console_common_v1_common]);

/**
 * @generated from message console.admin.v1.Key
 */
export type Key = Message<"console.admin.v1.Key"> & {
  /**
   * @generated from field: console.common.v1.KeyIdentity identity = 1;
   */
  identity?: KeyIdentity | undefined;

  /**
   * @generated from field: string created_by = 2;
   */
  createdBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp | undefined;

  /**
   * When it became current: its creation, for a key made since 2026-10-19.
   *
   * @generated from field: google.protobuf.Timestamp promoted_at = 4;
   */
  promotedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp retired_at = 5;
   */
  retiredAt?: Timestamp | undefined;

  /**
   * How many of the organization's active devices seal new collections under
   * this key (it is the current key each was last given), and how many exist.
   * For a retired key, those that have not renewed since it was replaced.
   *
   * @generated from field: uint32 devices_fetched = 7;
   */
  devicesFetched: number;

  /**
   * @generated from field: uint32 devices_active = 8;
   */
  devicesActive: number;

  /**
   * How the key is held: `workos-vault`, or `master-key` for one wrapped
   * under the console's master key and kept in its database.
   *
   * @generated from field: string held_in = 10;
   */
  heldIn: string;
};

/**
 * Describes the message console.admin.v1.Key.
 * Use `create(KeySchema)` to create a new message.
 */
export const KeySchema: GenMessage<Key> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 0);

/**
 * @generated from message console.admin.v1.MoveKeysRequest
 */
export type MoveKeysRequest = Message<"console.admin.v1.MoveKeysRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.MoveKeysRequest.
 * Use `create(MoveKeysRequestSchema)` to create a new message.
 */
export const MoveKeysRequestSchema: GenMessage<MoveKeysRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 1);

/**
 * @generated from message console.admin.v1.MoveKeysResponse
 */
export type MoveKeysResponse = Message<"console.admin.v1.MoveKeysResponse"> & {
  /**
   * @generated from field: uint32 moved = 1;
   */
  moved: number;

  /**
   * @generated from field: repeated console.admin.v1.Key keys = 2;
   */
  keys: Key[];
};

/**
 * Describes the message console.admin.v1.MoveKeysResponse.
 * Use `create(MoveKeysResponseSchema)` to create a new message.
 */
export const MoveKeysResponseSchema: GenMessage<MoveKeysResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 2);

/**
 * @generated from message console.admin.v1.RestoreKeysRequest
 */
export type RestoreKeysRequest = Message<"console.admin.v1.RestoreKeysRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.RestoreKeysRequest.
 * Use `create(RestoreKeysRequestSchema)` to create a new message.
 */
export const RestoreKeysRequestSchema: GenMessage<RestoreKeysRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 3);

/**
 * @generated from message console.admin.v1.RestoreKeysResponse
 */
export type RestoreKeysResponse = Message<"console.admin.v1.RestoreKeysResponse"> & {
  /**
   * @generated from field: uint32 restored = 1;
   */
  restored: number;

  /**
   * @generated from field: repeated console.admin.v1.Key keys = 2;
   */
  keys: Key[];
};

/**
 * Describes the message console.admin.v1.RestoreKeysResponse.
 * Use `create(RestoreKeysResponseSchema)` to create a new message.
 */
export const RestoreKeysResponseSchema: GenMessage<RestoreKeysResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 4);

/**
 * @generated from message console.admin.v1.ListKeysRequest
 */
export type ListKeysRequest = Message<"console.admin.v1.ListKeysRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.ListKeysRequest.
 * Use `create(ListKeysRequestSchema)` to create a new message.
 */
export const ListKeysRequestSchema: GenMessage<ListKeysRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 5);

/**
 * @generated from message console.admin.v1.ListKeysResponse
 */
export type ListKeysResponse = Message<"console.admin.v1.ListKeysResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.Key keys = 1;
   */
  keys: Key[];

  /**
   * Where the console keeps new keys: `workos-vault` or `master-key`.
   *
   * @generated from field: string key_store = 2;
   */
  keyStore: string;
};

/**
 * Describes the message console.admin.v1.ListKeysResponse.
 * Use `create(ListKeysResponseSchema)` to create a new message.
 */
export const ListKeysResponseSchema: GenMessage<ListKeysResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 6);

/**
 * Makes a new key the organization's current key, and retires the one it
 * replaces. Audited as `key.created`, and `key.retired` for the one replaced.
 *
 * @generated from message console.admin.v1.CreateKeyRequest
 */
export type CreateKeyRequest = Message<"console.admin.v1.CreateKeyRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * Left empty, the console assigns the next generation in the series the
   * organization's keys follow: `v1`, `v2`, and so on. A label given here
   * (`[a-z0-9]{1,16}`, unique within the organization) is used as it is.
   *
   * @generated from field: string generation = 2;
   */
  generation: string;

  /**
   * The generation the caller saw as current, which the new key replaces;
   * empty when it saw none. Refused as FAILED_PRECONDITION, with nothing
   * changed, when another key is current, so no key is replaced unseen.
   *
   * @generated from field: string replaces = 3;
   */
  replaces: string;
};

/**
 * Describes the message console.admin.v1.CreateKeyRequest.
 * Use `create(CreateKeyRequestSchema)` to create a new message.
 */
export const CreateKeyRequestSchema: GenMessage<CreateKeyRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 7);

/**
 * @generated from message console.admin.v1.CreateKeyResponse
 */
export type CreateKeyResponse = Message<"console.admin.v1.CreateKeyResponse"> & {
  /**
   * The new key, CURRENT.
   *
   * @generated from field: console.admin.v1.Key key = 1;
   */
  key?: Key | undefined;

  /**
   * The key it replaced, now RETIRED; unset for an organization's first.
   *
   * @generated from field: console.admin.v1.Key retired = 2;
   */
  retired?: Key | undefined;

  /**
   * Set when the key was made and something after it failed (the vault's
   * record of the organization's keys was not written): what, as a sentence.
   *
   * @generated from field: string warning = 3;
   */
  warning: string;
};

/**
 * Describes the message console.admin.v1.CreateKeyResponse.
 * Use `create(CreateKeyResponseSchema)` to create a new message.
 */
export const CreateKeyResponseSchema: GenMessage<CreateKeyResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 8);

/**
 * @generated from message console.admin.v1.DownloadEscrowRequest
 */
export type DownloadEscrowRequest = Message<"console.admin.v1.DownloadEscrowRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string generation = 2;
   */
  generation: string;

  /**
   * Required; recorded in the audit event.
   *
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message console.admin.v1.DownloadEscrowRequest.
 * Use `create(DownloadEscrowRequestSchema)` to create a new message.
 */
export const DownloadEscrowRequestSchema: GenMessage<DownloadEscrowRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 9);

/**
 * @generated from message console.admin.v1.DownloadEscrowResponse
 */
export type DownloadEscrowResponse = Message<"console.admin.v1.DownloadEscrowResponse"> & {
  /**
   * The formatted key string. Material.
   *
   * @generated from field: string key = 1;
   */
  key: string;
};

/**
 * Describes the message console.admin.v1.DownloadEscrowResponse.
 * Use `create(DownloadEscrowResponseSchema)` to create a new message.
 */
export const DownloadEscrowResponseSchema: GenMessage<DownloadEscrowResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_key, 10);

/**
 * The organization's external storage keys, managed by MotionSafe staff.
 * Org admins may call ListKeys to see generations, fingerprints, and states
 * (what a tablet shows, for comparison); every other RPC here is staff only.
 * The console only ever sees identities; material appears once, in
 * DownloadEscrow, which is audited.
 *
 * The state machine the console enforces (ARCHITECTURE.md §8.4):
 * CreateKey → CURRENT, previous CURRENT → RETIRED, in one step: there is no
 * staged key and no going back (decided 2026-10-19). A retired key is kept
 * forever: its material stays in escrow and a tablet fetches it to open a
 * card sealed under it, so every card ever sealed stays openable. There is no destroy operation, by design.
 * Every call is MotionSafe staff's: an organization's administrators see
 * neither its key nor its generations.
 *
 * @generated from service console.admin.v1.KeyService
 */
export const KeyService: GenService<{
  /**
   * @generated from rpc console.admin.v1.KeyService.ListKeys
   */
  listKeys: {
    methodKind: "unary";
    input: typeof ListKeysRequestSchema;
    output: typeof ListKeysResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.KeyService.CreateKey
   */
  createKey: {
    methodKind: "unary";
    input: typeof CreateKeyRequestSchema;
    output: typeof CreateKeyResponseSchema;
  },
  /**
   * The one place material is shown, for the offline copy the app's console
   * text tells administrators to keep. Audited as `key.escrow_downloaded`.
   *
   * @generated from rpc console.admin.v1.KeyService.DownloadEscrow
   */
  downloadEscrow: {
    methodKind: "unary";
    input: typeof DownloadEscrowRequestSchema;
    output: typeof DownloadEscrowResponseSchema;
  },
  /**
   * Moves every key of the organization that is held another way into the
   * store the console is set to use. Audited as `key.rewrapped`, one line a
   * key. The keys themselves do not change.
   *
   * @generated from rpc console.admin.v1.KeyService.MoveKeys
   */
  moveKeys: {
    methodKind: "unary";
    input: typeof MoveKeysRequestSchema;
    output: typeof MoveKeysResponseSchema;
  },
  /**
   * Rebuilds the organization's key registry from the vault, for a console
   * whose database lost it: every generation the vault's manifest names and
   * this database does not have comes back in the state it was in. Audited
   * as `key.restored`.
   *
   * @generated from rpc console.admin.v1.KeyService.RestoreKeys
   */
  restoreKeys: {
    methodKind: "unary";
    input: typeof RestoreKeysRequestSchema;
    output: typeof RestoreKeysResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_key, 0);

